import { ErrorCode, FileRejection } from 'react-dropzone'
import { EraImportStatus, EraImportSummary } from 'store/types'
import { ERA_ACCEPTED_EXTENSIONS, ERA_ACCEPTED_FILES } from 'ts-common/utils/eraFiles.utils'

// The picker filters on these, and anything else is refused with a message instead of being
// dropped silently (TES-3070). The list is shared with the S3 ERA inbox.
export { ERA_ACCEPTED_EXTENSIONS, ERA_ACCEPTED_FILES }

export function describeEraFileRejection(rejections: FileRejection[]): string {
  if (rejections.some(({ errors }) => errors.some(({ code }) => code === ErrorCode.TooManyFiles))) {
    return 'Select a single ERA file at a time.'
  }

  return rejections
    .map(({ file, errors }) => {
      if (errors.some(({ code }) => code === ErrorCode.FileInvalidType)) {
        return `"${file.name}" is not an accepted ERA file. Accepted extensions: ${ERA_ACCEPTED_EXTENSIONS.join(', ')}.`
      }
      const reason = errors.map(({ message }) => message).join('; ')
      return `"${file.name}" was not accepted${reason ? `: ${reason}` : '.'}`
    })
    .join(' ')
}

export type BulkEraUploadState = 'waiting' | 'uploading' | 'done' | 'failed' | 'stopped'

export type BulkEraUploadItem = {
  key: string
  filename: string
  state: BulkEraUploadState
  summary?: EraImportSummary
  error?: string
}

// How a finished file reads in the bulk upload: what the import did, or why
// the file never got in.
export type BulkEraUploadOutcome = 'imported' | 'partial' | 'duplicate' | 'empty' | 'failed' | 'pending'

export const bulkEraUploadOutcome = (item: BulkEraUploadItem): BulkEraUploadOutcome => {
  if (item.state === 'failed') return 'failed'
  if (item.state !== 'done' || !item.summary) return 'pending'

  switch (item.summary.status) {
    case EraImportStatus.PARTIALLY_IMPORTED:
      return 'partial'
    case EraImportStatus.DUPLICATE:
      return 'duplicate'
    case EraImportStatus.EMPTY:
      return 'empty'
    default:
      return 'imported'
  }
}
